import { Button, TextField } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Changes from "../../common/Changes";
import ApplyAll from "./ApplyAll";

function WagerLimitsDetails(props) {
  const { IdProfileLimits, IdGameType, Online } = props;
  const [data, setData] = useState([]);
  const [allValues, setAllValues] = useState(0);
  const [currentIdSport, setCurrentIdSport] = useState("");

  const fetchData = async () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const url =
      process.env.REACT_APP_API2_URL +
      `/Profile/PlayerProfileLimitsDetails_GetInfo?idProfileLimits=${IdProfileLimits}&idGameType=${IdGameType}&online=${Boolean(
        Online
      )}`;

    try {
      const response = await axios.get(url);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [IdProfileLimits, IdGameType, Online]);

  const handleInputChange = (index, field) => (e) => {
    const value = e.target.value;
    const updatedData = [...data];
    updatedData[index][field] = value;
    setData(updatedData);
  };

  const handleFocus = (index) => () => {
    setCurrentIdSport(data[index].idSport);
  };

  const handleAllChangeValues = (event, value) => {
    setAllValues(event ? event.target.value : value);
  };

  const handleButtonClick = async (onlineValue) => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const url =
      process.env.REACT_APP_API2_URL +
      "/Profile/PlayerProfileLimitsDetails_Update";

    // Map over data to create an array of promises for updating each row
    const updatePromises = data.map((row) => {
      const updateParams = {
        IdProfileLimits: props.IdProfileLimits,
        IdGameType: props.IdGameType,
        Online: Boolean(onlineValue),
        IdSport: row.idSport,
        Side: Number(row.side),
        Total: Number(row.total),
        MoneyLine: Number(row.moneyLine),
        Parlays: Number(row.parlays),
        Teasers: Number(row.teasers),
        IfBets: Number(row.ifBets),
        Reverses: Number(row.reverses),
        Related: Number(row.related),
        IdUser: userInfo.userId,
      };
      return axios.post(url, updateParams);
    });

    try {
      const responses = await Promise.all(updatePromises);
      // Handle the responses as needed
      console.log("Data updated:", responses);
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  const handleAllValuesClick = async () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const url =
      process.env.REACT_APP_API2_URL +
      "/Profile/PlayerProfileLimitsDetails_Update";

    // Map over data to create an array of promises for updating each row
    const updatePromises = data.map((row) => {
      const updateParams = {
        IdProfileLimits: props.IdProfileLimits,
        IdGameType: props.IdGameType,
        Online: Boolean(Online),
        IdSport: row.idSport,
        Side: Number(allValues),
        Total: Number(allValues),
        MoneyLine: Number(allValues),
        Parlays: Number(allValues),
        Teasers: Number(allValues),
        IfBets: Number(allValues),
        Reverses: Number(allValues),
        Related: Number(allValues),
        IdUser: userInfo.userId,
      };
      return axios.post(url, updateParams);
    });

    try {
      const responses = await Promise.all(updatePromises);
      // Handle the responses as needed
      console.log("Data updated:", responses);
      await fetchData(); // Recargar datos después de la actualización
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <div>
      <h2>Details</h2>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sport</th>
            <th>Side</th>
            <th>Total</th>
            <th>ML</th>
            <th>Parlays</th>
            <th>Teasers</th>
            <th>IfBets</th>
            <th>Reverses</th>
            <th>Related</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row.idSport}>
              <td>{row.idSport}</td>
              <td>
                <input
                  type="number"
                  value={row.side}
                  onChange={handleInputChange(index, "side")}
                  onFocus={handleFocus(index)}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.total}
                  onChange={handleInputChange(index, "total")}
                  onFocus={handleFocus(index)}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.moneyLine}
                  onChange={handleInputChange(index, "moneyLine")}
                  onFocus={handleFocus(index)}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.parlays}
                  onChange={handleInputChange(index, "parlays")}
                  onFocus={handleFocus(index)}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.teasers}
                  onChange={handleInputChange(index, "teasers")}
                  onFocus={handleFocus(index)}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.ifBets}
                  onChange={handleInputChange(index, "ifBets")}
                  onFocus={handleFocus(index)}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.reverses}
                  onChange={handleInputChange(index, "reverses")}
                  onFocus={handleFocus(index)}
                />
              </td>
              <td>
                <input
                  type="number"
                  value={row.related}
                  onChange={handleInputChange(index, "related")}
                  onFocus={handleFocus(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="flex flex-row gap-4">
        <TextField
          size="small"
          type="number"
          label="Set all values to"
          value={allValues}
          onChange={(event) => handleAllChangeValues(event, "MaxWager")}
          variant="outlined"
        />

        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={handleAllValuesClick}
        >
          Set
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => handleButtonClick(Online)}
        >
          Save
        </Button>

        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => handleButtonClick(!Online)}
        >
          {Online ? "Copy to Local" : "Copy to Online"}
        </Button>

        <Changes
          title={`Limits Changes`}
          buttonText={"Limits Changes"}
          params={{
            ChangeType: 24,
            IdSport: currentIdSport.trim(),
            Param1: props.IdProfileLimits,
            Param2: props.IdGameType,
            Param3: Online,
          }}
        />

        <ApplyAll
          title={`Apply to all`}
          buttonText={"Apply to all"}
          params={{
            ChangeType: 24,
            IdSport: currentIdSport.trim(),
            Param1: props.IdProfileLimits,
            Param2: props.IdGameType,
            Param3: Online,
          }}
        />
      </div>
    </div>
  );
}

export default WagerLimitsDetails;
